import React from "react";
import { CellContext } from "@tanstack/react-table";
import { AppContext } from "@/App";
import { PageLockContext } from "@/Components/PageLockProvider";
import DatePicker from "@/Components/ui/DatePicker";
import { dateformat } from "@/utils/GlobalConstants";
import { format } from "date-fns";

export const DueDateCell = ({ getValue, row: { index, original }, column: { id }, table }: CellContext<any, unknown>) => {
    const app = React.useContext(AppContext);
    const lock = React.useContext(PageLockContext);
    const editingEnabled = app.applicationUser?.userSettings?.inlineTableEditing ?? false;

    const initialValue = getValue<Date>()
    // We need to keep and update the state of the cell normally
    const [dueDate, setDueDate] = React.useState(initialValue)

    // When the input is blurred, we'll call our table meta's updateData function
    const onBlur = (date: Date) => {
        setDueDate(date);
        table.options.meta?.updateData(index, id, date)
    }

    // If the initialValue is changed external, sync it up with our state
    React.useEffect(() => {
        setDueDate(initialValue)
    }, [initialValue])

    const today = new Date();
    let style = "";
    if (new Date(dueDate as Date).getTime() < today.getTime() && original?.status !== "Closed") {
        style = " text-red-500";
    }

    if (app.authLevel !== 3 && !lock.viewOnly && editingEnabled) { // only allow editing for non-viewers
        return (
            <div className={"text-nowrap text-center" + style}>
                <DatePicker key={id + "_RiskDate"} ghost={true}
                    date={dueDate}
                    setDate={(value: Date | ((prevState: Date) => Date)) => {
                        if (value !== undefined && value !== null) {
                            onBlur(value as Date);
                        }
                    }}
                />
            </div>
        );
    }
    return <div className={"text-center" + style}>{format((dueDate as Date), dateformat)}</div>
};